import { Descendant, Editor, Element, Point, Range } from 'slate';
import { isTag } from './navigation';
import { OverlappingTag, TagElement } from '../types';

export const collectNestedTagIds = (element: TagElement): string[] => {
  const tagIds: string[] = [];
  const walk = (node: Descendant) => {
    if (Element.isElement(node)) {
      if (node.type === 'tag' && node.tagId !== element.tagId) {
        tagIds.push(node.tagId);
      }
      for (const child of node.children) {
        walk(child);
      }
    }
  };
  if (element.children) {
    for (const child of element.children) {
      walk(child);
    }
  }
  return tagIds;
};

export const getOverlappingTags = (editor: Editor, selection: Range | null): OverlappingTag[] => {
  if (!selection || Range.isCollapsed(selection)) return [];

  const overlapping: OverlappingTag[] = [];
  const [start, end] = Range.edges(selection);

  const tagEntries = Array.from(
    Editor.nodes(editor, {
      at: [],
      match: isTag,
    })
  );

  for (const [tagNode, tagPath] of tagEntries) {
    const tagRange = Editor.range(editor, tagPath);
    const [tagStart, tagEnd] = Range.edges(tagRange);

    // Check for partial overlap (not fully inside, not fully outside)
    const selectionStartsBeforeTag = Point.compare(start, tagStart) < 0;
    const selectionEndsAfterTag = Point.compare(end, tagEnd) > 0;
    const selectionStartsInsideTag = Point.compare(start, tagStart) >= 0 && Point.compare(start, tagEnd) < 0;
    const selectionEndsInsideTag = Point.compare(end, tagStart) > 0 && Point.compare(end, tagEnd) <= 0;

    // Partial overlap: selection starts before and ends inside, OR starts inside and ends after
    const startsBeforeEndsInside = selectionStartsBeforeTag && selectionEndsInsideTag && !selectionEndsAfterTag;
    const startsInsideEndsAfter = selectionStartsInsideTag && selectionEndsAfterTag && !selectionStartsBeforeTag;

    if (startsBeforeEndsInside || startsInsideEndsAfter) {
      overlapping.push({
        node: tagNode,
        path: tagPath,
        range: tagRange,
        overlapType: startsBeforeEndsInside ? 'start' : 'end',
      });
    }
  }

  return overlapping;
};
